import React, { FC, ReactNode } from "react";
import ReactPaginate from "react-paginate";
import { ChevronRight } from "assets/svg";

import { Wrapper } from "./styles";

const PaginationControl: FC<{ children: ReactNode }> = ({ children }) => (
  <button className="pagination__control">{children}</button>
);

const defaultPaginationConfig = {
  pageCount: 0,
  pageRangeDisplayed: 3,
  marginPagesDisplayed: 1,
};

export interface PaginationProps {
  className?: string;
  onPageChange: (page: number) => void | Promise<void>;
  totalCount: number;
  limit: number;
  page?: number;
}

/**
 * Pagination component
 * @param {string} [className] - Class name for the pagination container
 * @param {function} onPageChange - Function to handle page change
 * @param {number} totalCount - Total number of items
 * @param {number} limit - Number of items per page
 */
export const Pagination: FC<PaginationProps> = (props) => {
  const pageCount = Math.ceil(props.totalCount / props.limit);

  return (
    <Wrapper hidden={props.totalCount <= props.limit}>
      <ReactPaginate
        pageCount={pageCount || defaultPaginationConfig.pageCount}
        forcePage={props.page && props.page - 1}
        pageRangeDisplayed={defaultPaginationConfig.pageRangeDisplayed}
        marginPagesDisplayed={defaultPaginationConfig.marginPagesDisplayed}
        disableInitialCallback={true}
        onPageChange={({ selected }) => props.onPageChange(selected + 1)}
        breakClassName="pagination__link pagination__break"
        pageLinkClassName="pagination__link"
        containerClassName="pagination"
        previousLabel={
          <PaginationControl>
            <ChevronRight />
          </PaginationControl>
        }
        previousLinkClassName="pagination__prev"
        nextLabel={
          <PaginationControl>
            <ChevronRight />
          </PaginationControl>
        }
        nextLinkClassName="pagination__next"
        data-testid="pagination"
      />
    </Wrapper>
  );
};

export default Pagination;
